<div id="renew-reactivate" class="modal">
  <div class="mainModal">
    <div class="modal-content">
      <div class="modalContent">
        <div class="spouseImage">
          <img alt="Image" src="assets/icon/customise.svg" />
        </div>
        <p class="membership-disc">{{paymentDescription}}</p>
      </div>
      <ion-button mode="ios" expand="block" class="modalButton primary-gradient" (click)="closeModal()">
        {{'privacy_statement.proceed'| translate}}
      </ion-button>
    </div>
  </div>
</div>